import { apiSlice } from './apiSlice';

/**
 * Veriff identity check (the KYC Verification tab).
 *
 *   GET /v3/get/kyc/status/       → { is_verified, data: { status, admin_status } }
 *   GET /veriff/get/link/?retry=1 → { verification: { url, … } }
 *
 * `is_verified` is the answer the page reads; `data.status` ("completed") and
 * `data.admin_status` ("Manual Approved") describe how it got there. The link is
 * Veriff's own session-create answer, passed through: `verification.url` is
 * the hosted session to send the trader to. `retry` asks for a fresh session
 * after a rejected one; left out, fetchBaseQuery drops it.
 *
 * Fetched on the button's click rather than on load — each call may open a
 * session on Veriff's side, and the link goes stale — so it is a lazy query
 * that never serves a cached answer.
 */
export const veriffApi = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    getVeriffStatus: builder.query({
      query: () => '/v3/get/kyc/status/',
    }),

    getVeriffLink: builder.query({
      query: ({ retry } = {}) => ({
        url: '/veriff/get/link/',
        params: { retry: retry ? 1 : undefined },
      }),
      keepUnusedDataFor: 0,
    }),
  }),
});

export const { useGetVeriffStatusQuery, useLazyGetVeriffLinkQuery } = veriffApi;
